import { captureMessage } from '@sentry/nextjs'

interface ProductClickFieldsToValidate {
    category: string
    clickId: string
    customerId?: string
    productCode?: string
    scoreId?: string
}

export const logMissingProductClickFields = ({
    category,
    clickId,
    customerId,
    productCode,
    scoreId,
}: ProductClickFieldsToValidate): void => {
    const missingFields: string[] = []

    if (!customerId) missingFields.push('customerId')
    if (!scoreId) missingFields.push('scoreId')
    if (!productCode) missingFields.push('productCode')
    if (!clickId) missingFields.push('clickId')

    if (missingFields.length > 0) {
        captureMessage('product_click event missing critical data', {
            level: 'warning',
            tags: { productClick: true },
            extra: {
                missingFields,
                category,
                customerId,
                scoreId,
                productCode,
                clickId,
            },
        })
    }
}
